<template>
  <el-dialog
    title="快递模板"
    :visible.sync="visible"
    width="800px"
    append-to-body
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      stripe
      :data="list">
      <el-table-column
        label="模板ID"
        width="70"
        :resizable="false"
        prop="expressId"></el-table-column>
      <el-table-column
        label="快递名称"
        width="100"
        :resizable="false"
        prop="expressName"></el-table-column>
      <el-table-column
        label="模板名称"
        width="200"
        :resizable="false"
        prop="expressTempletName">
      </el-table-column>
      <el-table-column
        label="发件人"
        :resizable="false"
        prop="sender">
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="105">
        <template slot-scope="{ row }">
          <!-- <el-button
            type="warning"
            @click="edititem(row)">编辑</el-button> -->

          <el-dropdown>
            <el-button type="warning">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="edititem(row)">修改</el-dropdown-item>
              <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <template-edit-modal
        ref="modal"
        :callback="fetchCallback" />
      <!-- <el-button
        type="primary"
        @click="addItem">新增</el-button> -->
      <el-dropdown>
        <el-button type="primary">
          新增<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in expressList"
            :key="item.expressCode"
            @click.native="additem(item)">{{ item.expressName }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        style="margin-left:10px"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import TemplateEditModal from './template-edit-modal.vue'
// import CateEditModal from './cate-edit-modal.vue'
export default {
  name: 'SeriesModal',
  components: { TemplateEditModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      expressList: [],
      list: [],
      visible: false,
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {
        pageNum: 1,
        pageSize: 10
      }
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchCallback() {
      this.$store.dispatch('vendor/getexpresses', {
        payload: {
          vendorId: this.userInfo.orgId,
          pageNum: 1,
          pageSize: 10000
        },
        success: (res) => {
          localStorage.setItem('zs.expressList', JSON.stringify(res.data.records))
          this.$store.commit('account/setExpressList', res.data.records)
        },
        fail: () => {}
      }, { root: true })
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('vendor/getexpresses', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records.map(i => {
            return {
              ...i,
              sender: `${i.senderName}-${i.senderPhone}-${i.senderProvinceName}-${i.senderCityName}-${i.senderAreaName}-${i.senderAddress}`
            }
          })
          this.total = res.data.total
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.getallexpresses()
        this.toggleModal(true)
      })
    },
    additem(item) {
      this.$refs.modal.fetch(item)
    },
    edititem(row) {
      this.$refs.modal.fetch(row)
    },
    deleteitem(row) {
      this.$confirm('此操作将删除该物流模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('vendor/setvendorexpress', {
            payload: {
              vendorExpresses: [row],
              operFlag: 'del'
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    getallexpresses() {
      this.loading = true
      this.$store.dispatch('vendor/getallexpresses', {
        payload: {
          pageNum: 1,
          pageSize: 1000
        },
        success: (res) => {
          this.loading = false
          this.expressList = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
    // deleteItem(row) {
    //   this.$confirm('此操作将永久删除该品种, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       this.$store.dispatch('industry/deletecategory', {
    //         payload: {
    //           classId: row.classId
    //         },
    //         success: () => {
    //           this.loading = false
    //           // callback && callback()
    //           this.fetchList()
    //         },
    //         fail: () => {
    //           this.loading = false
    //           // cancel && cancel()
    //         }
    //       })
    //     })
    // }
  }
}
</script>
